
import React, { useEffect, useState, useMemo } from "react";
import { Layout, Menu, Avatar, Badge, Button, Divider, Spin } from "antd";
import { CloseOutlined, MenuOutlined, MoonOutlined, SunOutlined, FileTextOutlined, ExclamationCircleTwoTone } from '@ant-design/icons';
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    SettingOutlined,
    UserOutlined,
    LogoutOutlined,
    HistoryOutlined,
    MessageOutlined,
    ReloadOutlined,
} from "@ant-design/icons";
import { BiTransferAlt } from "@react-icons/all-files/bi/BiTransferAlt";
import { FaCity } from "@react-icons/all-files/fa/FaCity";
import { FcFilingCabinet } from "@react-icons/all-files/fc/FcFilingCabinet";
import { FcSettings } from "@react-icons/all-files/fc/FcSettings";
import { FcNook } from "@react-icons/all-files/fc/FcNook";
import { FaCar } from "@react-icons/all-files/fa/FaCar";
import { FcViewDetails } from "@react-icons/all-files/fc/FcViewDetails";
import { GiAutoRepair } from "@react-icons/all-files/gi/GiAutoRepair";
import { HiMiniDocumentCheck } from "react-icons/hi2";
import { FaTruckRampBox } from "react-icons/fa6";
import { IoPeopleSharp } from "react-icons/io5";
import { FaSitemap } from "react-icons/fa";
import { MdCarRepair, MdManageAccounts } from "react-icons/md";
import { TbBuildingWarehouse, TbSettingsDown, TbSettingsUp, TbTransferIn, TbTransferOut } from "react-icons/tb";
import { BsInboxesFill } from "react-icons/bs";
import { PiWarehouseFill } from "react-icons/pi";

import "./dashboard.css";
import withDashboardLogic from "../components/hoc_dashboard";
import { Outlet, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import headerBackground from '../icon/header.png';
import useSWR from 'swr';
import axios from 'axios';


const { Header, Sider, Content } = Layout;
const fetcher = (url: string) => axios.get(url).then(res => res.data);

interface DashboardProps {
    collapsed: boolean;
    toggleCollapsed: () => void;
    theme: string;
    toggleTheme: () => void;
    handleNavigation: (path: string) => void;
    showUserMenu: boolean;
    toggleUserMenu: () => void;
    handleLogout: () => void;
    remainingTime: number;
    formatTime: (ms: number) => string;
    loading: boolean;
}


const Dashboard: React.FC<DashboardProps> = ({
    collapsed,
    toggleCollapsed,
    theme,
    toggleTheme,
    handleNavigation,
    showUserMenu,
    toggleUserMenu,
    handleLogout,
    remainingTime,
    formatTime,
    loading
}) => {
    const { userData, isLoading, isOffline, isMaintenance } = useAuth();
    const { data: receiptCount } = useSWR(
        userData?.warehouse_code ? `${process.env.REACT_APP_BACKEND_URL}/api/item-wh-transfer-receipts/count?warehouse_code=${userData.warehouse_code}` : null,
        fetcher,
        { refreshInterval: 30000 }
    );
    const [isMounted, setIsMounted] = useState(false);
    const AgreementIcon = HiMiniDocumentCheck as React.ComponentType<any>;
    const SupplierMaster = FaTruckRampBox as React.ComponentType<any>;
    const CustomerMaster = IoPeopleSharp as React.ComponentType<any>;
    const ItemLocation = FaSitemap as React.ComponentType<any>;
    const ManagementUsers = MdManageAccounts as React.ComponentType<any>;
    const SettingUpdateItem = TbSettingsUp as React.ComponentType<any>;
    const WarehouseData = PiWarehouseFill as React.ComponentType<any>;
    const ServiceItemMaster = TbSettingsDown as React.ComponentType<any>;
    const RackLocation = BsInboxesFill as React.ComponentType<any>;



    const baseMenuItems = [
        {
            key: 'dashboard',
            icon: <FcViewDetails />,
            label: <Link to="/dashboard"
                onClick={(e) => {
                    e.preventDefault();
                    handleNavigation('/dashboard');
                }}
                style={{ color: 'inherit', textDecoration: 'none' }}
            >Dashboard
            </Link>,
        },
        {
            key: 'transacton',
            icon: <BiTransferAlt />,
            label: 'Transaction',
            children: [
                {
                    key: 'menu-approval',
                    label: <Link to="/dashboard/menu_approval"
                        onClick={(e) => {
                            e.preventDefault();
                            handleNavigation('/dashboard/menu_approval');
                        }}
                        style={{ color: 'inherit', textDecoration: 'none' }}
                    >Menu Approval
                    </Link>,
                    id: '020',
                    onClick: () => handleNavigation('/dashboard/menu_approval'),
                },
                {
                    key: 'log-spareparts',
                    label: 'Transaction Spareparts',
                    id: '027',
                    onClick: () => handleNavigation('/dashboard/log_spareparts'),
                },
                {
                    key: 'menu-sql',
                    label: 'Menu Sql',
                    id: '026',
                    onClick: () => handleNavigation('/dashboard/menu_sql'),
                },
                {
                    key: 'sales-estimation',
                    label: 'Sales Order',
                    id: '102',
                    onClick: () => handleNavigation('/dashboard/sales_estimation'),
                },
                {
                    key: 'picking_list',
                    label: 'Picking List',
                    id: '123',
                    onClick: () => handleNavigation('/dashboard/picking_list'),
                },
                {
                    key: 'picking_list_return',
                    label: 'Picking List Return',
                    id: '129',
                    onClick: () => handleNavigation('/dashboard/picking_list_return'),
                },
                {
                    key: 'packing_list',
                    label: 'Packing List',
                    id: '125',
                    onClick: () => handleNavigation('/dashboard/packing_list'),
                },
                {
                    key: 'sales_order_invoice_return',
                    label: 'Sales Order Invoice',
                    id: '127',
                    onClick: () => handleNavigation('/dashboard/sales_order_invoice'),
                },
                {
                    key: 'sales_order_invoice',
                    label: 'Sales Order Invoice Return',
                    id: '141',
                    onClick: () => handleNavigation('/dashboard/sales_order_invoice_return'),
                },
                {
                    key: 'data_cash_invoice',
                    label: 'Data Cash Invoice',
                    id: '143',
                    onClick: () => handleNavigation('/dashboard/data_cash_invoice'),
                },
                {
                    key: 'transaction_invoice',
                    label: 'Cash Management In',
                    id: '144',
                    onClick: () => handleNavigation('/dashboard/transaction_invoice'),
                },
                {
                    key: 'reycle_bin',
                    label: 'Reycle Bin Transaction',
                    id: '147',
                    onClick: () => handleNavigation('/dashboard/reycle_bin'),
                },
                {
                    key: 'purchase-request',
                    label: 'Purchase Request',
                    id: '107',
                    onClick: () => handleNavigation('/dashboard/purchase_request'),
                },
                {
                    key: 'purchase-order',
                    label: 'Purchase Order',
                    id: '112',
                    onClick: () => handleNavigation('/dashboard/purchase_order'),
                },
                {
                    key: 'inquiry-items',
                    label: 'Inquiry Items',
                    id: '119',
                    onClick: () => handleNavigation('/dashboard/inquiryitems'),
                },
                {
                    key: 'goods-receive',
                    label: 'Goods Receive',
                    id: '104',
                    onClick: () => handleNavigation('/dashboard/goods_receive'),
                },
                {
                    key: 'goods-receive-return',
                    label: 'Goods Receive Return',
                    id: '137',
                    onClick: () => handleNavigation('/dashboard/goods_receive_return'),
                }, {
                    key: 'adjustment',
                    label: 'Adjustment',
                    id: '024',
                    onClick: () => handleNavigation('/dashboard/adjustment'),
                },
                {
                    key: 'item-wh-transfer-request',
                    label: 'Item WH Transfer Request',
                    icon: <TbBuildingWarehouse />,
                    id: '139',
                    onClick: () => handleNavigation('/dashboard/item_wh_transfer_request'),
                },
                {
                    key: 'item-wh-transfer-receipt',
                    label: (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                Item Wh Transfer Receipt
                            </span>
                            {receiptCount?.count > 0 && (
                                <Badge
                                    count={receiptCount.count}
                                    size="small"
                                    style={{ flexShrink: 0, marginLeft: '8px' }}
                                />
                            )}
                        </div>
                    ),
                    icon: <TbBuildingWarehouse />,
                    id: '158',
                    onClick: () => handleNavigation('/dashboard/item_wh_transfer_receipt'),
                },
                {
                    key: 'item-wh-transfer-out',
                    label: 'Item Wh Transfer Out',
                    icon: <TbTransferOut />,
                    id: '160',
                    onClick: () => handleNavigation('/dashboard/item_wh_transfer_out'),
                },
                {
                    key: 'item-wh-transfer-in',
                    label: 'Item Wh Transfer In',
                    icon: <TbTransferIn />,
                    id: '159',
                    onClick: () => handleNavigation('/dashboard/item_wh_transfer_in'),
                },
                {
                    key: 'work-order',
                    label: 'Work Order',
                    icon: <MdCarRepair />,
                    id: '203',
                    onClick: () => handleNavigation('/dashboard/work_order'),
                },
                {
                    key: 'work-order-allocation',
                    label: 'Work Order Allocation',
                    icon: <MdCarRepair />,
                    id: '205',
                    onClick: () => handleNavigation('/dashboard/work_order_allocation'),
                },
                {
                    key: 'attendance-mechanic',
                    label: 'Attendance Mechanic',
                    icon: <MdCarRepair />,
                    id: '205',
                    onClick: () => handleNavigation('/dashboard/attendance_mechanic'),
                },
                {
                    key: 'work-order-invoice',
                    label: 'Work Order Invoice',
                    icon: <MdCarRepair />,
                    id: '009',
                    onClick: () => handleNavigation('/dashboard/work_order_invoice'),
                },
                {
                    key: 'invoice-return-work-order',
                    label: 'Invoice Return Work Order',
                    icon: <MdCarRepair />,
                    id: '016',
                    onClick: () => handleNavigation('/dashboard/invoice_return_work_order'),
                },
                {
                    key: 'supply-slip',
                    label: 'Supply Slip',
                    icon: <MdCarRepair />,
                    id: '010',
                    onClick: () => handleNavigation('/dashboard/supply_slip'),
                },
                {
                    key: 'supply-slip-return',
                    label: 'Supply Slip Return',
                    icon: <MdCarRepair />,
                    id: '012',
                    onClick: () => handleNavigation('/dashboard/supply_slip_return'),
                },
            ],
        },
        {
            key: 'master',
            icon: <FcFilingCabinet />,
            label: 'Master',
            children: [
                {
                    key: 'item-location',
                    icon: <ItemLocation />,
                    label: 'Item Location',
                    id: '154',
                    onClick: () => handleNavigation('/dashboard/item_location'),
                },
                {
                    key: 'rack_location',
                    icon: <RackLocation />,
                    label: 'List Rack Location',
                    id: '021',
                    onClick: () => handleNavigation('/dashboard/rack_location'),
                },
                {
                    key: 'customer-master',
                    icon: <CustomerMaster />,
                    label: 'Customer Master',
                    id: '131',
                    onClick: () => handleNavigation('/dashboard/customer_master'),
                },
                {
                    key: 'supplier-master',
                    icon: <SupplierMaster />,
                    label: 'Supplier Master',
                    id: '114',
                    onClick: () => handleNavigation('/dashboard/supplier_master'),
                },
                {
                    key: 'agreement',
                    icon: <AgreementIcon />,
                    label: 'Agreement',
                    id: '106',
                    onClick: () => handleNavigation('/dashboard/agreement'),
                },
                {
                    key: 'spareparts_master',
                    icon: <GiAutoRepair />,
                    label: 'Spareparts Master',
                    id: '120',
                    onClick: () => handleNavigation('/dashboard/spareparts_master'),
                },
                {
                    key: 'service_item_master',
                    icon: <ServiceItemMaster />,
                    label: 'Service Item Master',
                    id: '005',
                    onClick: () => handleNavigation('/dashboard/service_item_master'),
                },
                {
                    key: 'vehicle_master',
                    icon: <FaCar />,
                    label: 'Vehicle Master',
                    id: '201',
                    onClick: () => handleNavigation('/dashboard/vehicle_master'),
                },
                {
                    key: 'sales-substitution',
                    label: 'Sales Substitution',
                    id: '151',
                    onClick: () => handleNavigation('/dashboard/sales_substitution'),
                },


            ],
        },
        {
            key: 'report',
            icon: <FcNook />,
            label: 'Report',
            children: [
                {
                    key: 'sparepart-sales-customer',
                    label: 'Sparepart Sales By Customer',
                    id: '149',
                    onClick: () => handleNavigation('/dashboard/sparepart_sales_customer'),
                },
                {
                    key: 'sales_invoice_profit_report',
                    label: 'Invoice Profit Report',
                    id: '018',
                    onClick: () => handleNavigation('/dashboard/sales_invoice_profit_report'),
                },
                {
                    key: 'reycle_bin',
                    label: 'Reycle Bin Transaction',
                    id: '147',
                    onClick: () => handleNavigation('/dashboard/reycle_bin'),
                },
                {
                    key: 'export_part',
                    label: 'Export Data Stock Spareparts',
                    id: '023',
                    onClick: () => handleNavigation('/dashboard/export_part'),
                },
                {
                    key: 'work_order_report',
                    label: 'Work Order Report',
                    id: '028',
                    onClick: () => handleNavigation('/dashboard/work_order_report'),
                },
            ],
        },
        {
            key: 'register',
            icon: <FileTextOutlined />,
            label: 'Register',
            children: [
                {
                    key: 'x',
                    label: 'xx',
                    id: 'xxx',
                    onClick: () => handleNavigation('/dashboard/sparepart_sales_customer'),
                },
            ],
        },
        {
            key: 'setting',
            icon: <FcSettings />,
            label: 'Setting',
            children: [
                {
                    key: 'management-user',
                    icon: <ManagementUsers />,
                    label: 'Management User',
                    id: '132',
                    onClick: () => handleNavigation('/dashboard/management_user'),
                },
                {
                    key: 'setting-update-item-spareparts',
                    icon: <SettingUpdateItem />,
                    label: 'Setting Update Item Part',
                    id: '157',
                    onClick: () => handleNavigation('/dashboard/setting_update_item_spareparts'),
                },
                {
                    key: 'setting-overtime-work-allocation',
                    icon: <SettingUpdateItem />,
                    label: 'Setting Overtime Work Allocation',
                    id: '013',
                    onClick: () => handleNavigation('/dashboard/setting_overtime_work_allocation'),
                },
                {
                    key: 'warehouse',
                    label: 'Data Warehouse',
                    icon: <WarehouseData />,
                    id: '133',
                    onClick: () => handleNavigation('/dashboard/warehouse'),
                },
                {
                    key: 'foreman-data',
                    icon: <ManagementUsers />,
                    label: 'Foreman Data',
                    id: '001',
                    onClick: () => handleNavigation('/dashboard/foreman_data'),
                },
            ],
        },
    ];


    const filterMenuItems = useMemo(() => {
        if (userData?.users === 'edp') {
            return baseMenuItems;
        }
        if (!userData || !userData.menu_otoritas) {
            return [];
        }

        const allowedIds = new Set(userData.menu_otoritas.split(';').map(id => id.trim()).filter(Boolean));

        const filter = (items: any[]): any[] => {
            return items.reduce((acc: any[], item: any) => {
                if (item.children) {
                    const filteredChildren = filter(item.children);
                    if (filteredChildren.length > 0) {
                        acc.push({ ...item, children: filteredChildren });
                    }
                } else {
                    if (item.key === 'dashboard' || (item.id && allowedIds.has(item.id))) {
                        acc.push(item);
                    }
                }
                return acc;
            }, []);
        };

        return filter(baseMenuItems);
    }, [userData, handleNavigation]);

    const handleRefreshCache = async () => {
        try {
            const bypassToken = Date.now().toString();
            try {
                await fetch(`${window.location.origin}${window.location.pathname}?v=${bypassToken}`, {
                    method: 'GET',
                    headers: {
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Pragma': 'no-cache',
                        'Expires': '0'
                    },
                    cache: 'reload'
                });
            } catch (e) {
                console.warn("Pre-fetch failed", e);
            }
            if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(cacheNames.map(name => caches.delete(name)));
            }
            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations();
                await Promise.all(registrations.map(r => r.unregister()));
            }
            sessionStorage.clear();
            const cleanUrl = new URL(window.location.origin + window.location.pathname);
            cleanUrl.searchParams.set('v', bypassToken);
            window.location.href = cleanUrl.toString() + window.location.hash;
        } catch (error) {
            window.location.reload();
        }
    };

    const userMenuItems = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: 'Profile',
        },
        {
            key: 'account',
            icon: <SettingOutlined />,
            label: 'Account Settings',
        },
        {
            key: 'activity',
            icon: <HistoryOutlined />,
            label: 'Activity',
        },
        {
            key: 'Message',
            icon: <MessageOutlined />,
            label: 'Message',
        },
        {
            key: 'refresh-cache',
            icon: <ReloadOutlined />,
            label: 'Refresh Cache',
            onClick: handleRefreshCache,
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Log Out',
            danger: true,
            onClick: handleLogout,
        },
    ];


    const [isMobile, setIsMobile] = useState(false);
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);



    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 780);
            if (width > 780) setMobileMenuVisible(false);
        };

        window.addEventListener("resize", handleResize);
        handleResize();
        setIsMounted(true);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
        <Layout className={`dashboard-wrapper ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`} data-theme={theme} style={{ opacity: isMounted ? 1 : 0, transition: 'opacity 0.2s ease-in-out' }}>
            {isMaintenance && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, width: '100vw', height: '100vh',
                    background: 'rgba(0, 0, 0, 0.85)',
                    zIndex: 99999,
                    display: 'flex', flexDirection: 'column',
                    justifyContent: 'center', alignItems: 'center',
                    color: '#fff', textAlign: 'center', padding: '20px'
                }}>
                    <Spin size="large" style={{ marginBottom: '20px' }} />
                    <h2 style={{ color: '#fff' }}>System AMP Under Maintenance </h2>
                    <p>System has been Update. Please Wait...</p>
                </div>
            )}
            {isOffline && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, width: '100vw', height: '100vh',
                    background: 'rgba(0, 0, 0, 0.85)',
                    zIndex: 99999,
                    display: 'flex', flexDirection: 'column',
                    justifyContent: 'center', alignItems: 'center',
                    color: '#fff', textAlign: 'center', padding: '20px'
                }}>
                    <Spin size="large" style={{ marginBottom: '20px' }} />
                    <h2 style={{ color: '#fff' }}>Koneksi Terputus</h2>
                    <p>Sambungan internet Anda tidak stabil. Silakan periksa koneksi Anda.</p>
                </div>
            )}
            <div
                className={`user-menu-panel ${showUserMenu ? 'visible' : ''}`}
                onClick={toggleUserMenu}
            >
                <div className="user-menu-content" onClick={(e) => e.stopPropagation()}>
                    <Button
                        type="text"
                        icon={<CloseOutlined />}
                        onClick={toggleUserMenu}
                        className="close-user-menu-btn"
                        style={{ position: 'absolute', right: 16, top: 16 }}
                    />
                    <div className="user-profile-section">
                        <Avatar
                            size={64}
                            icon={<UserOutlined />}
                            className="profile-avatar"
                            style={{ backgroundColor: '#87d068' }}
                        />
                        {!isLoading && (
                            <div className="user-info">
                                <h3 className="user-name">{userData?.nama || 'User Name'}</h3>
                                <p className="user-position">{userData?.jabatan || 'Position'}</p>
                                <p className="user-department"><FaCity /></p>
                                <p className="user-department"> {userData?.dealer_name || 'Department'}</p>
                                <p className="user-department">Warehouse: {userData?.warehouse_name || 'N/A'}</p>
                                {isMobile && (
                                    <div className="session-timer">
                                        Session expires in: <span>{formatTime(remainingTime)}</span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <Divider style={{ margin: '16px 0' }} />
                    <Menu
                        items={userMenuItems}
                        mode="inline"
                        selectable={false}
                        className="user-menu-list"
                    />
                </div>
            </div>
            { }
            {isMobile && mobileMenuVisible && (
                <div
                    className="mobile-overlay"
                    onClick={() => setMobileMenuVisible(false)}
                />
            )}
            <Layout style={{ minHeight: "100vh" }}>
                { }
                <Sider
                    className={`sidebar ${mobileMenuVisible ? 'mobile-visible' : ''}`}
                    collapsed={isMobile ? false : collapsed}
                    trigger={null}
                    collapsible
                    width={isMobile ? '75%' : 250}
                    collapsedWidth={80}
                >
                    { }
                    <div className="logo">
                        <img
                            src={require("../icon/amp_login.png")}
                            alt="Logo"
                            style={{ height: "40px", margin: "16px" }}
                        />
                    </div>

                    { }
                    <Menu
                        theme="light"
                        mode="inline"
                        items={filterMenuItems}
                        inlineCollapsed={collapsed}
                        defaultOpenKeys={[]}
                        defaultSelectedKeys={['dashboard']}
                    />
                </Sider>

                { }
                <Layout className="site-layout" >
                    { }
                    <Header className="site-header" style={{ backgroundImage: `url(${headerBackground})`, backgroundPosition: 'left' }}>
                        {!isMobile && (
                            <Button
                                type="text"
                                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                                onClick={toggleCollapsed}
                                className="trigger"
                            />
                        )}
                        {isMobile && (
                            <Button
                                type="text"
                                icon={mobileMenuVisible ? <CloseOutlined /> : <MenuOutlined />}
                                onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
                                className="mobile-menu-toggle"
                            />
                        )}
                        <div className="header-titles">
                            <h1 className="welcome-title">Welcome {userData?.nama || 'User Name'} | {userData?.jabatan || 'Position'}</h1>
                            <p className="company-subtitle">
                                {isMobile ? 'PT. Auto Mobile Prima' : 'PT. Auto Mobil Prima | After Sales Sparepart Management System'}
                            </p>
                            <div className="session-timer">
                                {formatTime(remainingTime)}
                            </div>
                        </div>

                        { }
                        <div className="header-actions">
                            <Badge count={8}>
                                <ExclamationCircleTwoTone className="action-icon" />
                            </Badge>
                            {/* <Badge dot>
                                <SettingOutlined className="action-icon" />
                            </Badge> */}
                            <Avatar
                                style={{ backgroundColor: "#0099ffff" }}
                                icon={<UserOutlined />}
                                className="user-avatar"
                                onClick={toggleUserMenu}
                            />
                            <Button
                                icon={theme === 'light' ? <MoonOutlined /> : <SunOutlined />}
                                onClick={toggleTheme}
                                className="theme-toggle"
                            />
                        </div>
                    </Header>

                    { }
                    <Content className="site-content">
                        <div className="content-wrapper">
                            <Spin spinning={loading} tip="Memuat..." size="large">
                                <div style={{ padding: '0 8px' }}>
                                    { }
                                    <Outlet /> { }
                                </div>
                            </Spin>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </Layout >
    );
};

export default withDashboardLogic(Dashboard);